/* eslint-disable */
import PropTypes from 'prop-types';
import { AUTH_SERVICE_ROLE_ADMIN, AUTH_SERVICE_ROLE_BATCHER } from '../../Constants/Auth/Auth.constants';
import UserEntityPropTypes from '../User/User.service.props';

/**
 * The current `auth`
 */
const auth = PropTypes.shape({
  /**
   * The `accesstoken` shape
   */
  accessToken: PropTypes.shape({
    /**
     * The url to use to authorise this token
     */
    authorizeUrl: PropTypes.string.isRequired,

    /**
     * The claims that this token has access to
     */
    claims: PropTypes.object.isRequired,

    /**
     * When the `token` expires
     */
    expiresAt: PropTypes.number.isRequired,

    /**
     * The scopes that thi token is requesting
     */
    scopes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,

    /**
     * The `accessToken`
     */
    token: PropTypes.string.isRequired,

    /**
     * The `type` of token. Eg `Bearer`
     */
    type: PropTypes.string.isRequired,

    /**
     * The url to use to get an `idToken`
     */
    userinfoUrl: PropTypes.string.isRequired,
  }),

  /**
   * The `accessToken`
   */
  id: PropTypes.string.isRequired,

  /**
   * The `idToken` shape
   */
  idToken: PropTypes.shape({
    /**
     * The _audience_ of the id token. Typically, this is the **clientId**
     */
    aud: PropTypes.string.isRequired,

    /**
     * The url to use to authorise this token
     */
    authorizeUrl: PropTypes.string.isRequired,

    /**
     * The claims that this token has access to
     */
    claims: PropTypes.object.isRequired,

    /**
     * When the `token` expires
     */
    expiresAt: PropTypes.number.isRequired,

    /**
     * When this token was issued
     */
    iat: PropTypes.number.isRequired,

    /**
     * The entity that issued this token
     */
    iss: PropTypes.string.isRequired,

    /**
     * The scopes that thi token is requesting
     */
    scopes: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,

    /**
     * The `accessToken`
     */
    token: PropTypes.string.isRequired,

    /**
     * The `type` of token. Eg `Bearer`
     */
    type: PropTypes.string.isRequired,
  }),

  /**
   * The `sessionToken` shape
   */
  sessionToken: PropTypes.shape({
    /**
     * When the `token` expires
     */
    expiresAt: PropTypes.number.isRequired,

    /**
     * The possible sessions that the user has access to
     */
    sessions: PropTypes.arrayOf(
      PropTypes.shape({
        /**
         * Whether or not this token is the currently logged in token
         */
        current: PropTypes.bool.isRequired,

        /**
         * When the `token` expires
         */
        expiresAt: PropTypes.number.isRequired,

        /**
         * The `sessionToken`
         */
        token: PropTypes.string.isRequired,
      }).isRequired,
    ).isRequired,

    /**
     * The `sessionToken`
     */
    token: PropTypes.string.isRequired,

    /**
     * The `type` of token. Eg `SSWS`
     */
    type: PropTypes.string.isRequired,
  }),

  /**
   * The user that is authorised to use these tokens
   */
  user: UserEntityPropTypes.user.isRequired,
});

/**
 * The remaining duration for the `accessToken`
 */
const authExpiry = PropTypes.number;

/**
 * The roles of the current `auth`
 */
const authRoles = PropTypes.oneOf([AUTH_SERVICE_ROLE_ADMIN, AUTH_SERVICE_ROLE_BATCHER]);

const AuthEntityPropTypes = {
  /**
   * The current `auth`
   */
  auth,

  /**
   * The remaining duration for the `accessToken`
   */
  authExpiry,

  /**
   * The roles of the current `auth`
   */
  authRoles,
};

export default AuthEntityPropTypes;
